module.exports = __webpack_public_path__ + "static/media/AZ.da4f4d9d.svg";